var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6894 18.7743C14.0601 19.2934 14.7786 19.3458 15.2134 18.8858L15.3034 18.7905C15.6534 18.4199 15.6991 17.8358 15.4114 17.4093L10.9593 11.966L15.4113 6.59028C15.699 6.16384 15.6534 5.57968 15.3033 5.20912L15.2133 5.11382C14.7786 4.6537 14.0601 4.70626 13.6893 5.2253L8.60496 11.3194C8.33171 11.702 8.33171 12.2301 8.60496 12.6125L13.6894 18.7743Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftIcon);
export default __webpack_public_path__ + "static/media/chevron_left_icon.f4df6506aad16dc0cd03d0b4db42bb03.svg";
export { ForwardRef as ReactComponent };